var supportsWebMAlpha = function (callback) {
  var hevcAlphaTestVideo = document.createElement('video');
  if (hevcAlphaTestVideo.canPlayType && hevcAlphaTestVideo.canPlayType('video/mp4; codecs="hvc1"') !== '') {
    callback(true);
    return;
  }

  const is_ios = /iP(ad|od|hone)/i.test(window.navigator.userAgent),
    is_safari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
  if (is_ios && is_safari) {
    // iOS Safari does not support transparent WebM at all (June 2025), but the test below passes!!!
    // Therefore, we must return false here. I might check this all again in a year or two, as safari mobile may support transparent webm by then!
    callback(false);
    return;
  }

  var vid = document.createElement('video');
  vid.autoplay = false;
  vid.loop = false;
  vid.style.display = 'none';
  vid.addEventListener(
    'loadeddata',
    function () {
      document.body.removeChild(vid);
      // Create a canvas element, this is what user sees.
      var canvas = document.createElement('canvas');

      //If we don't support the canvas, we definitely don't support webm alpha video.
      if (!(canvas.getContext && canvas.getContext('2d'))) {
        callback(false);
        return;
      }

      // Get the drawing context for canvas.
      var ctx = canvas.getContext('2d');

      // Draw the current frame of video onto canvas.
      ctx.drawImage(vid, 0, 0);
      if (ctx.getImageData(0, 0, 1, 1).data[3] === 0) {
        callback(true);
      } else {
        callback(false);
      }
    },
    false,
  );
  vid.addEventListener('error', function () {
    document.body.removeChild(vid);
    callback(false);
  });

  vid.addEventListener('stalled', function () {
    document.body.removeChild(vid);
    callback(false);
  });

  //Just in case
  vid.addEventListener('abort', function () {
    document.body.removeChild(vid);
    callback(false);
  });

  var source = document.createElement('source');
  source.src =
    'data:video/webm;base64,GkXfowEAAAAAAAAfQoaBAUL3gQFC8oEEQvOBCEKChHdlYm1Ch4ECQoWBAhhTgGcBAAAAAAACBRFNm3RALE27i1OrhBVJqWZTrIHlTbuMU6uEFlSua1OsggEjTbuMU6uEHFO7a1OsggHo7AEAAAAAAACqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmAQAAAAAAADIq17GDD0JATYCNTGF2ZjU3LjU3LjEwMFdBjUxhdmY1Ny41Ny4xMDBEiYhARAAAAAAAABZUrmsBAAAAAAAARq4BAAAAAAAAPdeBAXPFgQGcgQAitZyDdW5khoVWX1ZQOYOBASPjg4QCYloA4AEAAAAAAAARsIFAuoFAmoECU8CBAVSygQQfQ7Z1AQAAAAAAAGfngQCgAQAAAAAAAFuhooEAAACCSYNCAAPwA/YAOCQcGFQAADBgAABnP///NXgndmB1oQEAAAAAAAAtpgEAAAAAAAAk7oEBpZ+CSYNCAAPwA/YAOCQcGFQAADBgAABnP///Vttk7swAHFO7awEAAAAAAAARu4+zgQC3iveBAfGCAXXwgQM=';
  source.addEventListener('error', function () {
    document.body.removeChild(vid);
    callback(false);
  });
  vid.appendChild(source);

  //This is required for IE
  document.body.appendChild(vid);
};

supportsWebMAlpha(function (result) {
  if (result) {
    // console.log('Supports WebM Alpha');
  } else {
    console.log("Doesn't support WebM Alpha");
    document.documentElement.classList.add('web-m-alpha-not-supported');
  }
});
